import * as ReactDOM from "react-dom";
import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import { SurveyQuestion } from "../../../types";
import getControlProps from "../helpers/getControlProps";

interface MultiSelectQuestionProps {
  onChange: any;
  question: SurveyQuestion;
  answer: any;
  error: string;
}

class MultiSelectQuestion extends React.Component<
  MultiSelectQuestionProps,
  {}
> {
  select: any;

  componentDidMount() {
    this.clearSelectedOptions();
    this.hydrateSelectedOptions();
  }

  /**
   * The first option in an uncontrolled multi select will be selected
   * by default, so we need to make sure it's clear.
   */

  clearSelectedOptions() {
    const options = this.select.options;

    for (let i = 0, l = options.length; i < l; i++) {
      options[i].selected = false;
    }
  }

  hydrateSelectedOptions() {
    const answer = this.props.answer || [];
    const options = this.select.options;

    answer.forEach((answer: string) => {
      for (let i = 0, l = options.length; i < l; i++) {
        if (options[i].value === answer) {
          options[i].selected = true;
        }
      }
    });
  }

  onChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const value = [];
    const options = e.currentTarget.options;

    for (let i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    this.props.onChange(this.props.question, value);
  };

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <select
          multiple
          onChange={this.onChange}
          onClick={this.onChange}
          ref={select => {
            this.select = select;
          }}
          {...getControlProps(this.props.question, this.props.error)}
        >
          {this.props.question.SurveyQuestionChoices.map((choice: any) => {
            return (
              <option key={choice.ChoiceID} value={choice.ChoiceText}>
                {choice.ChoiceText}
              </option>
            );
          })}
        </select>
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default MultiSelectQuestion;
